module.exports = __webpack_public_path__ + "img/quest_icon_0011_heart.d2ec7e35.png";